import { render, staticRenderFns } from "./procurementnonnike.vue?vue&type=template&id=c6b59212&scoped=true&"
import script from "./procurementnonnike.vue?vue&type=script&lang=js&"
export * from "./procurementnonnike.vue?vue&type=script&lang=js&"
import style0 from "./procurementnonnike.vue?vue&type=style&index=0&id=c6b59212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b59212",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
